export const iconFontAwesomeArrowsSortUp = (
	<i className="fa-solid fa-sort-up"></i>
);
